import { inject } from 'langium';
import { createDefaultModule, createDefaultSharedModule, } from 'langium/lsp';
import { PypestreamPifGeneratedModule, PypestreamPifGeneratedSharedModule, } from './generated/module.js';
import { PypestreamPifValidator, registerValidationChecks, } from './pypestream-pif-validator.js';
import { CommandsMetadataService } from './commands-metadata-service.js';
import { FeatureFlagsService } from './feature-flags-service.js';
import { KeywordValueConverter } from './keyword-value-converter.js';
/**
 * Dependency injection module that overrides Langium default services and contributes the
 * declared custom services. The Langium defaults can be partially specified to override only
 * selected services, while the custom services must be fully specified.
 */
export const PypestreamPifModule = {
    parser: {
        ValueConverter: () => new KeywordValueConverter(),
    },
    validation: {
        PypestreamPifValidator: () => new PypestreamPifValidator(),
    },
    commandsMetadataService: () => new CommandsMetadataService(),
    featureFlagsService: () => new FeatureFlagsService(),
};
/**
 * Create the full set of services required by Langium.
 *
 * First inject the shared services by merging two modules:
 *  - Langium default shared services
 *  - Services generated by langium-cli
 *
 * Then inject the language-specific services by merging three modules:
 *  - Langium default language-specific services
 *  - Services generated by langium-cli
 *  - Services specified in this file
 *
 * @param context Optional module context with the LSP connection
 * @param featureFlags Optional feature flags to configure the compiler behavior
 * @returns An object wrapping the shared services and the language-specific services
 */
export function createPypestreamPifServices(context, featureFlags) {
    const shared = inject(createDefaultSharedModule(context), PypestreamPifGeneratedSharedModule);
    const PypestreamPif = inject(createDefaultModule({ shared }), PypestreamPifGeneratedModule, PypestreamPifModule, {
        featureFlagsService: () => new FeatureFlagsService(featureFlags),
    });
    shared.ServiceRegistry.register(PypestreamPif);
    registerValidationChecks(PypestreamPif);
    if (!context.connection) {
        // We don't run inside a language server
        // Therefore, initialize the configuration provider instantly
        shared.workspace.ConfigurationProvider.initialized({});
    }
    return { shared, PypestreamPif };
}
//# sourceMappingURL=pypestream-pif-module.js.map